const GENERIC_API_MESSAGES = new Set([
  'bad request',
  'internal error',
  'not found',
  'forbidden',
  'unauthorized'
]);

const parseResponseData = data => {
  if (typeof data === 'string') {
    const trimmed = data.trim();
    if (!trimmed) {
      return null;
    }

    try {
      return JSON.parse(trimmed);
    } catch (error) {
      return { message: trimmed };
    }
  }

  if (data && typeof data === 'object') {
    return data;
  }

  return null;
};

export default function extractApiErrorMessage(error) {
  const payload = parseResponseData(error?.response?.data);

  if (payload?.message && typeof payload.message === 'string') {
    const message = payload.message.trim();
    if (message && !GENERIC_API_MESSAGES.has(message.toLowerCase()) && message !== payload.code) {
      return message;
    }
  }

  if (error?.message && !error.message.startsWith('Request failed with status code')) {
    return error.message;
  }

  return 'Unexpected error occured, try again later';
}
